module.exports = __webpack_public_path__ + "img/sale-01.2384b318.svg";